import { render, staticRenderFns } from "./ArrayField.vue?vue&type=template&id=02608cdf&lang=pug&"
import script from "./ArrayField.vue?vue&type=script&lang=js&"
export * from "./ArrayField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02608cdf')) {
      api.createRecord('02608cdf', component.options)
    } else {
      api.reload('02608cdf', component.options)
    }
    module.hot.accept("./ArrayField.vue?vue&type=template&id=02608cdf&lang=pug&", function () {
      api.rerender('02608cdf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inspector/fields/ArrayField.vue"
export default component.exports